import React from 'react';

import cn from './style.module.scss';

export function Description() {
  return <p className={cn.stepViewDescription}>Now fill out the techniques.</p>;
}
